import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'evolvtax';
  url: string;
  usr_dtls: any;
  citizen_dtls: any;
  constructor(public router: Router,
    public toastr: ToastrService) {
    let localData = localStorage.getItem('userDetails');
    let citizenData = localStorage.getItem('data');
    // console.log(citizenData);
    
    // if(localData) {
    //   this.usr_dtls = JSON.parse(localData);
    // }

    // if(this.usr_dtls) {
    //   this.url = this.router.url;
    //   console.log(this.url)
    // } else {
    //   this.router.navigateByUrl('login-admin')
    // }

    // if (citizenData) {
    //   this.citizen_dtls = citizenData;
    //   console.log(this.citizen_dtls);
    // }

    // if (this.citizen_dtls) {
    //   this.url = this.router.url;
    //   console.log(this.url);
    // } 
    // else {
    //   this.router.navigateByUrl('home');
    // }
  }
}
